<a *ngIf="showResend && +rowData?.re_status == 1" href="javascript:void(0)" class="status-link text-link" (click)="onClick()"> <img [src] = "resendIcon" alt="Resend Report" ngbTooltip="Resend report"> </a>

<span *ngIf="+rowData?.re_status == 0">Report Deleted</span>
